module.exports = __webpack_public_path__ + "img/asan4.19516a9a.png";